export enum ETicketStatus {
  Novo = 1,
  Atribuído = 2,
  Planejado = 3,
  Pendente = 4,
  Solucionado = 5,
  Fechado = 6
}

export interface IComment {
  id: number;
  customer_id: number;
  content: string;
  self: boolean;
  created_at: string;
  updated_at: string;
}

export interface ITicket {
  id: number;
  content: string;
  status: number;
  title: string;
  created_at: string;
  updated_at: string;
  solved_at: string | null;
  comments: IComment[];
}
